import { zodResolver } from '@hookform/resolvers/zod'
import { isNumber } from 'lodash'
import { useForm, type DefaultValues } from 'react-hook-form'
import { z } from 'zod'

import i18n from '@/i18n'
import { labelAndValue } from '@/utils/zod'

export const sectionFormSchema = z.object({
  course: labelAndValue(),
  schoolYears: labelAndValue(),
  curriculum: labelAndValue(),
  // should this be kept in form?
  areLessonBlocksEnabled: z.boolean(),
  lessonBlocks: z.array(
    z
      .object({
        semesterNumber: labelAndValue(z.number()).optional(),
        hours: z.number().min(1).nullable()
      })
      .superRefine((value, ctx) => {
        if (!isNumber(value.semesterNumber?.value)) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ['semesterNumber'],
            message: i18n.t('error.required-field-with-label', {
              ns: 'common',
              LABEL: i18n.t('label.semester-number', { ns: 'sections' })
            })
          })
        }

        if (!isNumber(value.hours)) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ['hours'],
            message: i18n.t('error.required-field-with-label', {
              ns: 'common',
              LABEL: i18n.t('label.hours', { ns: 'sections' })
            })
          })
        }
      })
  )
})

export type SectionFormValues = z.infer<typeof sectionFormSchema>

const SECTION_FORM_DEFAULT_VALUES: DefaultValues<SectionFormValues> = {
  course: undefined,
  schoolYears: undefined,
  curriculum: undefined
}

export const useSectionForm = (defaultValues = SECTION_FORM_DEFAULT_VALUES) =>
  useForm<SectionFormValues>({
    resolver: zodResolver(sectionFormSchema),
    defaultValues,
    mode: 'onBlur'
  })
